import React from 'react';
import { EntityIcon } from 'components/Global/EntityItem/styled';
import { ChecklistItemContainer, ChecklistItemName, ChecklistTick } from './styled';

const EntityFilterItem = ({ data, onClick, selectedItems = [], selectedKey = 'public_id', showLogo }) => {
  const selected = selectedItems.includes(data[selectedKey]);
  return (
    <ChecklistItemContainer selected={selected} onClick={() => onClick(data)}>
      {showLogo && <EntityIcon height="19px" width="19px" logo_url={data.logo_url} />}
      <ChecklistTick selected={selected} />
      <ChecklistItemName selected={selected}>{data.name}</ChecklistItemName>
    </ChecklistItemContainer>
  );
};

export default EntityFilterItem;
